
import { defineComponent } from "vue";

export default defineComponent({
  name: 'TournamentCard',

  props: {
    match: { type: Object, required: true },
    isFinals: { type: Boolean, default: false },
  },

  computed: {
    playerOne: ({ match }: any) => match.players[0],
    playerTwo: ({ match }: any) => match.players[1],
  },

  methods: {
    getPlayerIcon({ icon: { name } }: any): string {
      return name ?? 'question';
    },
  },
});
